export default __webpack_public_path__ + "static/media/iconSearch.8290fc22.svg";